import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { FETCH_INTERVAL_MS } from "../constants";

interface LeaderboardCountdownProps {
  lastUpdatedAt: number;
}

function getSecondsRemaining(lastUpdatedAt: number): number {
  const nextRefreshAt = lastUpdatedAt + FETCH_INTERVAL_MS;
  const remainingMs = nextRefreshAt - Date.now();
  return Math.max(0, Math.ceil(remainingMs / 1000));
}

export function LeaderboardCountdown({
  lastUpdatedAt,
}: LeaderboardCountdownProps) {
  const [secondsRemaining, setSecondsRemaining] = useState(() =>
    getSecondsRemaining(lastUpdatedAt),
  );

  useEffect(() => {
    setSecondsRemaining(getSecondsRemaining(lastUpdatedAt));

    const interval = setInterval(() => {
      const next = getSecondsRemaining(lastUpdatedAt);
      setSecondsRemaining(next);
    }, 1000);

    return () => clearInterval(interval);
  }, [lastUpdatedAt]);

  return (
    <p className={styles.countdown} aria-live="polite">
      Leaderboard update in {secondsRemaining}s
    </p>
  );
}
